export default "__VITE_ASSET__d48ce122__"